import React from 'react';

import {
  Row,
  Col,
  DatePicker,
  Input,
  List,
  notification,
  Button,
  Modal,
} from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import { Link } from 'react-router-dom';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getDepositos from '../../../graphql/querys/ventas/getDepositos.graphql';
import deleteDeposito from '../../../graphql/mutations/venta/deleteDeposito.graphql';
import { errorService } from '../../../graphql/utils/utils';

const InputGroup = Input.Group;
const { RangePicker } = DatePicker;

const confirm = Modal.confirm;

@compose(
  graphql(getDepositos),
  graphql(deleteDeposito, {
    name: 'deleteDeposito',
    options: {
      refetchQueries: [{ query: getDepositos }],
    },
  })
)
class VerDepositos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      fechaInicial: null,
      fechaFinal: null,
      primeraCarga: true,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  _executeSearch = async () => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getDepositos, deposito => {
      return (
        deposito.organismo.nombre.indexOf(this.state.filtro.toUpperCase()) > -1
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 5);
      }
    );
  };

  filtrarPorFechas = async () => {
    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getDepositos, deposito => {
      return (
        deposito.fecha >=
          this.state.fechaInicial
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate()
            .getTime() &&
        deposito.fecha <=
          this.state.fechaFinal
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate()
            .getTime()
      );
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 5);
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.data.getDepositos && this.props.data.getDepositos) {
      // console.log("PASO 2")
      this.setState(
        {
          ...this.state,
          listaTotal: this.props.data.getDepositos,
        },
        function() {
          this.ordenarLista(1, 5);
        }
      );
    }

    if (this.state.primeraCarga && this.props.data.getDepositos) {
      // console.log("PASO 3");
      this.setState(
        {
          ...this.state,
          listaTotal: this.props.data.getDepositos,
          primeraCarga: false,
        },
        function() {
          this.ordenarLista(1, 5);
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        deposito => {
          return deposito.fecha;
        },
      ],
      ['desc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChangeFechas = (date, dateString) => {
    // console.log(date);
    // console.log(dateString);
    this.setState({
      ...this.state,
      fechaInicial: date[0] ? date[0] : '',
      fechaFinal: date[1] ? date[1] : '',
    });
  };

  borrarFiltros = () => {
    this.setState(
      {
        ...this.state,
        filtro: '',
        fechaInicial: null,
        fechaFinal: null,
        listaTotal: this.props.data.getDepositos,
      },
      function() {
        this.ordenarLista(1, 5);
      }
    );
  };

  onDelete(id_deposito) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar el deposito con id ", id_deposito);

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este deposito?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteDeposito({
            variables: { _id: id_deposito },
          })
          .then(res => {
            let id = res.data.deleteDeposito;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);
              notification.warning({
                message: 'Deposito eliminado',
                description: 'Se ha eliminado el deposito exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el deposito');
            console.log(err);
            errorService(err, {
              _id: id_deposito,
            });
            Modal.error({
              title: 'Error en la eliminacion del deposito',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { loading } = this.state;

    const Search = Input.Search;

    const pagination = {
      pageSize: 5,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <Row>
          <Col span={24} offset={0}>
            <Search
              placeholder="Ingrese el deposito para buscarla"
              enterButton="Buscar"
              onChange={e => this.setState({ filtro: e.target.value })}
              onSearch={() => this._executeSearch()}
              size="large"
              style={{ margin: 10, width: '96%' }}
            />
            <InputGroup compact>
              <RangePicker
                value={[this.state.fechaInicial, this.state.fechaFinal]}
                style={{ width: '70%', marginLeft: 10 }}
                onChange={this.onChangeFechas}
              />
              <Button
                type="primary"
                disabled={!this.state.fechaInicial || !this.state.fechaFinal}
                onClick={this.filtrarPorFechas}
              >
                {' '}
                Filtrar por fechas{' '}
              </Button>
              <Button
                type="default"
                style={{ marginLeft: 20 }}
                onClick={this.borrarFiltros}
              >
                {' '}
                Reiniciar Filtros{' '}
              </Button>
            </InputGroup>
          </Col>
        </Row>
        <List
          className="demo-loadmore-list"
          loading={loading}
          itemLayout="horizontal"
          pagination={pagination}
          dataSource={this.state.lista}
          renderItem={item => (
            <List.Item
              style={{ margin: 15 }}
              actions={[
                <Button
                  key="editar"
                  onClick={() =>
                    this.props.history.push(`/admin/depositos/${item._id}`)
                  }
                >
                  Editar
                </Button>,
                <Button
                  key="eliminar"
                  type="danger"
                  onClick={() => this.onDelete(item._id)}
                >
                  Eliminar
                </Button>,
              ]}
            >
              <List.Item.Meta
                title={
                  <Link to={`/admin/depositos/${item._id}`}>
                    <h2>
                      {item.organismo.nombre} de ${item.importe} con fecha de{' '}
                      {moment(item.fecha).format('DD/MM/YYYY')}
                    </h2>
                  </Link>
                }
                description={
                  <h3>
                    {' '}
                    Realizado en: {item.sucursal.nombre} con el numero de boleta
                    de: {item.numBoletaDeposito}{' '}
                  </h3>
                }
              />
              {/* <div><p> Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido usó una galería de textos y los mezcló de tal manera que logró hacer un libro de textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto de relleno en documentos electrónicos, quedando esencialmente igual al original. Fue popularizado en los 60s con la creación de las hojas "Letraset", las cuales contenian pasajes de Lorem Ipsum, y más recientemente con software de autoedición, como por ejemplo Aldus PageMaker, el cual incluye versiones de Lorem Ipsum.</p></div> */}
            </List.Item>
          )}
        />
      </div>
    );
  }
}

export default withApollo(VerDepositos);
